<template>
  <section class="section-gallery">
    <div class="gallery-container" @scroll="scrollHandler">
      <div class="gallery-image-tools-overpanel" v-if="currentImage && isUserAuthorized(currentImage)">
        <vue-qr class="gallery-image-qrcode" :text="qrCodeURL(currentImage)" qid="photoQR" v-if="currentImage.showQrCode"></vue-qr>
        <div class="gallery-image-tools-container in-single-img">
          <ion-icon name="share-social-outline" title="Compartilhar" @click.stop="shareMaterial(currentImage)"></ion-icon>
          <ion-icon name="chatbubble-ellipses-outline" title="Postar" @click.stop="postImage(currentImage.links)" v-if="userAbleToPost(currentImage)"></ion-icon>
          <ion-icon name="qr-code-outline" title="QR Code" @click.stop="currentImage.showQrCode = !currentImage.showQrCode"></ion-icon>
          <ion-icon name="download-outline" title="Download" @click.stop="downloadMaterial(currentImage)"></ion-icon>
          <ion-icon name="trash-outline" title="Remover" @click.stop="deleteMaterial(currentImage)" v-if="isUserAuthorized(currentImage)"></ion-icon>
        </div>
      </div>
      <VueGallery :options="vueGalleryOptions" :images="imagesSrc" :index="index" @close="closeSingleView" />
      <div class="image-card-container" v-for="(image, imageIndex) in images" :key="imageIndex">
        <div class="imageBox" @click.prevent="openSingleView(imageIndex, image)">
          <img class="image" :src="image.links" alt />
          <div @click.stop="openHost(image)">
            <vue-qr class="gallery-qrcode" :text="qrCodeURL(image)" qid="photoQR" v-if="image.showQrCode"></vue-qr>
          </div>
          <div class="gallery-image-tools-container" v-if="isUserAuthorized(image)">
            <ion-icon name="share-social-outline" title="Compartilhar" @click.stop="shareMaterial(image)"></ion-icon>
            <ion-icon name="chatbubble-ellipses-outline" title="Postar" @click.stop="postImage(image.links)" v-if="userAbleToPost(image)"></ion-icon>
            <ion-icon name="qr-code-outline" title="QR Code" @click.stop="showHideQrCode(image)"></ion-icon>
            <ion-icon name="download-outline" title="Download" @click.stop="downloadMaterial(image)"></ion-icon>
            <ion-icon name="trash-outline" title="Remover" @click.stop="deleteMaterial(image)" v-if="isUserAuthorized(image)"></ion-icon>
          </div>
        </div>
      </div>
    </div>

    <!-- POST COMPOSER -->
    <PostComposer style="z-index: 1000000" :key="postComposerKey" :post="post" :showComposer="showPostComposer" @closeClick="postImage" />
  </section>
</template>

<script>
import api from '@/services/api';
import VueGallery from 'vue-gallery';
import PostComposer from '@/components/general/PostComposer.vue';
import VueQr from 'vue-qr';

export default {
  name: 'Gallery',
  components: {
    PostComposer,
    VueGallery,
    VueQr,
  },
  props: ['images', 'imagesSrc', 'activityData'],
  data() {
    return {
      isAdmin: false,
      index: null,
      currentImage: null,
      postComposerKey: '',
      showPostComposer: false,
      post: { media: { images: [] } },
      windowFeatures: { width: 485, height: 600 },
      vueGalleryOptions: {
        disableScroll: true,
        enableKeyboardNavigation: false,
      },
    };
  },

  methods: {
    isUserAuthorized(image) {
      if (this.isAdmin || this.$store.state.user.id === image.created_by_user) return true;
      else return false;
    },
    userAbleToPost(image) {
      if (this.$store.state.template.enableSocialFeed && image.created_by_user == this.$store.state.user.id) return true;
    },
    postImage(imageSrc) {
      this.showPostComposer = !this.showPostComposer;
      this.post.media.images.push(imageSrc);
      this.post.media.parsedImage = imageSrc;
      this.postComposerKey = this.$RNG.randomKey();
    },
    downloadMaterial(image) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      const newImage = new Image();
      newImage.crossOrigin = 'Anonymous';

      newImage.onload = function () {
        canvas.width = newImage.width;
        canvas.height = newImage.height;
        ctx.drawImage(newImage, 0, 0);
        const a = document.createElement('a');
        a.href = canvas.toDataURL('image/jpeg', 1.0);
        a.download = image.name;
        a.click();
      };

      newImage.src = image.links + `?${new Date().getTime()}}`;
    },
    shareMaterial(image) {
      const materialData = {
        title: this.activityData.property.shareTitle ?? image.name,
        text: this.activityData.property.shareText ?? image.description,
        // url: `https://${location.host}/#/hosted/?material=${image.links}`,
        files: [],
      };

      if (navigator.share && navigator.canShare && navigator.canShare(materialData)) {
        fetch(image.links + `?${new Date().getTime()}`)
          .then((res) => res.blob())
          .then((blob) => {
            const file = new File([blob], image.name, { type: blob.type });
            materialData.files = [file];

            navigator
              .share(materialData)
              .then(() => console.log('Successful share'))
              .catch((error) => console.log('Error sharing', error));
          })
          .catch((err) => console.error(err));
      }
    },
    deleteMaterial(image) {
      this.$modal.show('dialog', {
        title: 'ATENÇÂO! Ação não recuperável',
        text: 'Deseja excluir material?',
        buttons: [
          {
            title: 'Sim',
            handler: async () => {
              try {
                await api.post(`event/${this.$store.state.eventId}/materialDeleteList`, {
                  list_id: [image.material_id],
                });

                this.index = null;
                this.images.splice(this.images.indexOf(image), 1);
                this.imagesSrc.splice(this.imagesSrc.indexOf(image.links), 1);
              } catch (error) {
                console.error(error);
              }

              this.$modal.hide('dialog');
            },
          },
          {
            title: 'Não',
            default: true,
            handler: () => {
              this.$modal.hide('dialog');
            },
          },
        ],
      });
    },
    qrCodeURL(image) {
      return `https://${location.host}/#/hosted/?material=${image.links}`;
    },
    showHideQrCode(image) {
      image.showQrCode = !image.showQrCode;
    },
    openHost(image) {
      this.$router.push({ name: 'Hosted', query: { material: image.links } });
    },
    openSingleView(imageIndex, image) {
      this.index = imageIndex;
      this.currentImage = image;
    },
    closeSingleView() {
      this.index = null;
      if (this.currentImage) this.currentImage.showQrCode = false;
      this.currentImage = null;
    },
    scrollHandler(e) {
      if (e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight) {
        console.log('scrolling to bottom');
        this.$emit('scrollBottom');
      }
      if (e.target.scrollTop === 0) {
        console.log('scrolling to top');
        this.$emit('scrollTop');
      }
    },
  },

  beforeMount() {
    this.isAdmin = this.$store.state.user.role === '1819bd5e-7b46-11ea-bc55-0242ac130003' || this.$store.state.user.role === '1819bea8-7b46-11ea-bc55-0242ac130003'; //operators and admins
  },
};
</script>

<style lang="scss">
.gallery-container {
  position: relative;
  background-color: var(--main-color);
  display: flex;
  flex-wrap: wrap;
  min-height: 75vh;
  justify-content: center;
  padding: 2% 0 4%;
  max-height: 100dvh;
  overflow: auto;

  .blueimp-gallery-display {
    height: 100dvh !important;
  }

  .blueimp-gallery-controls > .close {
    position: absolute;
    top: auto;
    bottom: 0;
    right: 0;
    left: 0;
    margin: 0;
    font-size: 30px;
    text-decoration: none;
    cursor: pointer;
  }

  .blueimp-gallery > .prev,
  .blueimp-gallery > .next {
    display: none;
  }

  .slides {
    height: 100dvh !important;
    pointer-events: none !important;
  }
}

.gallery-image-tools-overpanel {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 80px;
  z-index: 1000000;
  width: 100%;
  pointer-events: none;

  display: flex;
  align-items: center;
  justify-content: center;

  .gallery-image-qrcode {
    position: relative;
  }

  .in-single-img {
    z-index: 1000000;
    pointer-events: auto;
    padding: 6px 10px;
  }
}
.image-card-container {
  position: relative;
  height: 100%;
}
.image-card-actions {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  padding: 2px;
  height: max-content;
  border: none;
  border-radius: 10px;
  background: #ffffff80;

  & i {
    font-size: 0.9rem;
    color: #000000 !important;
  }
}
.imageBox {
  cursor: pointer;
  display: flex;
  background-color: transparent;
  padding: 0px;
}
.image {
  width: 310px;
  height: auto;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  margin: 6px;
}
.social-share-facebook {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 10px;
  background: teal;
}
.gallery-qrcode {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 180px;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
  pointer-events: auto !important;
  z-index: 1;
  cursor: grab;

  &:hover {
    opacity: 1;
  }
}
.gallery-image-tools-container {
  position: absolute;
  bottom: 38px;
  left: 50%;
  transform: translateX(-50%);
  right: auto;
  padding: 4px 10px;
  z-index: 1;
  background: #0007;
  border-radius: 4px 4px 0 0;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;

  opacity: 1;
  transition: opacity 0.3s ease-in-out;

  &:hover {
    opacity: 1;
  }

  i,
  ion-icon {
    font-size: 1.5rem;
    color: #ffffff;
    opacity: 0.8;
    cursor: pointer;

    &:hover {
      opacity: 1;
    }
  }
}
</style>
